<template>
    <v-form
        v-model="formValid"
        :autocomplete="autocomplete"
        @input="handleValid"
        @submit.prevent
    >
        <w-form-field-set v-bind="wFormFieldSetProps" :disabled="readonly">
            <!-- @slot-->
            <slot></slot>
        </w-form-field-set>
        <!-- @slot actions-->
        <slot name="actions"></slot>
    </v-form>
</template>

<script>
    import WFormMixin from '../../mixins/forms/w-form-mixin'
    import WFormFieldSet from '../WFormFieldSet'

    /**
     * A basic form wrapper
     */
    export default {
        name: 'WForm',
        mixins: [WFormMixin],
        components: {WFormFieldSet}
    }
</script>
